import { type FC } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { IconUser } from '@tabler/icons-react';
import clsx from 'clsx';

interface Props {
  user: string
  userAvatar?: string
  content: string
  date: Date
}

const ForumAnswer: FC<Props> = ({ user, userAvatar, content, date }) => {
  const formattedDate = format(new Date(date), 'HH:mm - dd MMM yyyy', { locale: es });

  return (
    <div className={clsx(
      'flex gap-3 p-4 rounded-lg border-2 transition-all duration-300',
      'bg-gray-50 border-gray-200',
      'dark:bg-surface-medium dark:border-borders',
      'hover:shadow-md'
    )}>
      {/* Avatar */}
      <div className="flex-shrink-0">
        {userAvatar ? (
          <img
            src={userAvatar}
            alt={user}
            className="w-10 h-10 rounded-full object-cover border-2 border-gray-200 dark:border-borders"
          />
        ) : (
          <div className={clsx(
            'w-10 h-10 rounded-full flex items-center justify-center',
            'bg-gradient-to-br from-indigo-500 to-purple-500',
            'dark:from-indigo-600 dark:to-purple-600'
          )}>
            <IconUser size={18} className="text-white" />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1.5">
          <span className={clsx(
            'font-semibold text-sm transition-colors duration-300',
            'text-gray-900 dark:text-white'
          )}>
            {user}
          </span>
          <span className={clsx(
            'text-xs transition-colors duration-300',
            'text-gray-500 dark:text-gray-400'
          )}>
            {formattedDate}
          </span>
        </div>
        <p className={clsx(
          'text-sm leading-relaxed transition-colors duration-300',
          'text-gray-700 dark:text-gray-300'
        )}>
          {content}
        </p>
      </div>
    </div>
  );
};

export { ForumAnswer };
